var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-container',[(!_vm.loading)?_c('v-form',{ref:"form",attrs:{"action":_vm.action,"model":_vm.model}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }